/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */

type ProjectNameLike = {
    title?: string | null;
    idn?: string | null;
};

export const getProjectName = (project?: ProjectNameLike) => {
    return project?.title || project?.idn || 'Project';
};
